export default __webpack_public_path__ + "static/media/4-4.18c6ba0d.png";